import React from 'react';
import { Link } from "react-router-dom";
import "../../styles/support/support.css";
import ReactTooltip from "react-tooltip";

const Support = () => {
    return(
        <div className="support_screen">
            <Link to={"/main_back/support/about_us"} className="support_screen_container_link"><div className="support_screen_container">About Us</div></Link>
            <Link to={"/main_back/support/contact_us"} className="support_screen_container_link"><div className="support_screen_container">Contact Us</div></Link>
            {/* <Link to={"/main_back/support/support_us"} className="support_screen_container_link"><div className="support_screen_container">Support Us</div></Link> */}
            <div data-tip data-for="support_us" className="support_screen_container">Support Us</div>
            <ReactTooltip effect='float' id="support_us" place="top">Unavaible at the moment.</ReactTooltip>
        </div>
    );
};

export default Support;